import React from "react";

interface ChatDayBreakProps {
  date: Date;
  onJumpToDate?: (date: Date) => void;
}

export function ChatDayBreak({ date, onJumpToDate: _onJumpToDate }: ChatDayBreakProps) {
  // Dropdown functionality disabled for now - keeping code for future use
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(event.target as Node)
  //     ) {
  //       setIsDropdownOpen(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);
  const formatDate = (date: Date): string => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Check if it's today
    if (date.toDateString() === today.toDateString()) {
      return "Today";
    }

    // Check if it's yesterday
    if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    }

    // For anything past yesterday, use "Monday, 9 July" format
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: date.getFullYear() !== today.getFullYear() ? "numeric" : undefined,
    });
  };

  // Dropdown functionality disabled for now - keeping code for future use
  // const handleJumpTo = (targetDate: Date) => {
  //   if (onJumpToDate) {
  //     onJumpToDate(targetDate);
  //   }
  //   setIsDropdownOpen(false);
  // };

  return (
    <div className="flex items-center justify-center my-4 relative">
      <div className="flex w-full h-[1px] z-0  left-0 right-0  bg-slate-200 dark:bg-slate-200/20"></div>

      {/* Dropdown functionality disabled for now - keeping code for future use */}
      {/* <div className="relative" ref={dropdownRef}>
        <div
          className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 dark:bg-slate-800 rounded-full text-sm text-slate-600 dark:text-slate-400 font-medium cursor-pointer hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span>{formatDate(date)}</span>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`text-xs transition-transform ${
              isDropdownOpen ? "rotate-180" : ""
            }`}
          />
        </div>

        {isDropdownOpen && (
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700 min-w-48 z-50">
            <div className="py-1">
              <div className="px-3 py-2 text-xs text-slate-500 dark:text-slate-400 font-medium">
                Jump to...
              </div>
              {getJumpToOptions().map((option, index) => (
                <button
                  key={index}
                  className="w-full text-left px-3 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
                  onClick={() => handleJumpTo(option.date)}
                >
                  {option.label}
                </button>
              ))}
              <div className="border-t border-slate-200 dark:border-slate-700 my-1"></div>
              <button className="w-full text-left px-3 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                Jump to a specific date
              </button>
            </div>
          </div>
        )}
      </div> */}

      {/* Simple date display for now */}
      <div className="px-6 flex-none py-1.5 z-10 relative uppercase tracking-widest font-mono rounded-full text-sm text-slate-500 font-medium">
        <span>{formatDate(date)}</span>
      </div>
      <div className="flex w-full h-[1px] z-0  left-0 right-0  bg-slate-200 dark:bg-slate-200/20"></div>
    </div>
  );
}
